"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Returns a new path starting from the subject of the current path.
 *
 * Requires:
 * - (optional) a subject property on the path proxy
 * - (optional) a parent property on the path proxy
 */

var SubjectHandler =
/*#__PURE__*/
function () {
  function SubjectHandler() {
    _classCallCheck(this, SubjectHandler);
  }

  _createClass(SubjectHandler, [{
    key: "handle",
    value: function handle(pathData) {
      // Traverse parents until we find a subject
      var subject = pathData.subject,
          parent = pathData.parent;

      while (!subject && parent) {
        var _parent = parent;
        subject = _parent.subject;
        parent = _parent.parent;
      } // Resolve the subject if it exists,
      // and return a path starting from that subject


      return !subject ? undefined : Promise.resolve(subject).then(function (value) {
        return pathData.extendPath({
          subject: value
        }, null);
      });
    }
  }]);

  return SubjectHandler;
}();

exports.default = SubjectHandler;